import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import TrackingNumberColumn from '../../../components/columns/tracking-number-column';
import Global from '../../../store/global-selectors';
import { messages } from '../messages';

import style from './style.module.less';

const TrackingNumberColumnContainer = ({ fulfillmentId }) => {
  const { labelFulfillment, trackingInformation } =
    useSelector((state) => Global.selectEntitiesFulfillmentById(state, { fulfillmentId })) ?? {};

  const { isLabelVoided } = labelFulfillment ?? {};

  return (
    <div
      className={classNames({
        [style['voided-tracking-number']]: isLabelVoided,
      })}
    >
      <TrackingNumberColumn shouldRenderIcon={!isLabelVoided} trackingSummary={trackingInformation} />
    </div>
  );
};

TrackingNumberColumnContainer.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};

export const TrackingNumber = {
  getMessageDescriptor: () => messages.trackingNumber,
  id: 'tracking-number',

  render: (data) => {
    if (!data) {
      return '';
    }
    return <TrackingNumberColumnContainer fulfillmentId={data.id} />;
  },
};
